import React from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import { Box, SxProps } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(0.5),
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    zIndex: 1,
  },
}));

export interface ModalProps {
  children: React.ReactNode;
  open: boolean;
  handleClose: () => void;
  sx?: SxProps<Theme>;
}

// modal for waiting to join a room
const AvataraModal = ({ open, handleClose, children, sx }: ModalProps) => {
  const classes = useStyles();

  return (
    <Modal
      className={classes.modal}
      open={open}
      onClose={handleClose}
      aria-labelledby="knock-wait-modal"
      aria-describedby="knock-wait-modal"
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        {/* <div className={classes.paper}>{children}</div> */}
        <Box
          sx={{
            backgroundColor: theme => theme.palette.background.paper,
            borderRadius: theme => theme.spacing(0.5),
            boxShadow: theme => theme.shadows[5],
            padding: theme => theme.spacing(2, 4, 3),
            zIndex: 1,
            ...sx,
          }}
        >
          {children}
        </Box>
      </Fade>
    </Modal>
  );
};

export default AvataraModal;
